module.exports = __webpack_public_path__ + "linea-basic-10.177764eadf43efc393eb.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/linea/basic/fonts/linea-basic-10.svg
// module id = ../../../../../src/assets/fonts/linea/basic/fonts/linea-basic-10.svg
// module chunks = styles